import moment from 'moment';

export function orchDataConsumption(bucketSize, value) {
    var currUnit = "kB", maxUnit = "MB", currVal = "0", maxVal = "0"
    if (bucketSize === 0) { bucketSize = 1; }
    if (value > bucketSize) { value = bucketSize }

    if ((bucketSize - value) < 1024) {
        currUnit = "kB"
        currVal = (bucketSize - value)
    } else if (Math.round((bucketSize - value) / 1024) % 1024 === 0) {
        currUnit = "GB"
        currVal = Math.round((bucketSize - value) / 1048576)
    } else {
        currUnit = "MB"
        currVal = (Math.round((bucketSize - value) / 10.24) / 100).toString().replace(/\./, ',')
    }
    if ((parseInt(bucketSize) >= 1048576 ) && (((parseInt(bucketSize) / 1024) % 1024 == 0)) || ((Math.round((bucketSize || 0) / 10.24) / 100) % 1024 === 0)) {
        maxUnit = "GB"
        maxVal = (Math.round(parseInt(bucketSize) / 1048576)).toString()
    } else {
        maxUnit = "MB"
        maxVal = (Math.round((bucketSize || 0) / 10.24) / 100).toString().replace(/\./, ',')
    }

    if (currUnit == maxUnit) {
        return currVal + " / " + maxVal + " " + maxUnit
    } else {
        return currVal + " " + currUnit + " / " + maxVal + " " + maxUnit
    }
}

export function getRateplanVersion(pd) {
    let res = { result: false, rplnShort: '' };
    if ((pd || '').toLowerCase().indexOf('t karta') !== -1) {
        res = { result: true, rplnShort: 'tkarta' };
    } else if((pd || '').toLowerCase().indexOf('pecka') !== -1) {
        res = { result: true, rplnShort: 'pecka' };        
    } else {
        res.rplnShort = 'other';
        res.rplnOrig = pd;
    }
    return res;
}

export function mixiNameNotSeven(bname, btype, prolongObj) {
    let days = 7;
    if (prolongObj[bname]) {
        const bTypeArr = btype.split('MenuPackage');
        if (bTypeArr[1]) {
            if (!isNaN((bTypeArr[1]).slice(0,1))) {
                days = parseInt((String(bTypeArr[1])).replace(/\D/g, ''));
            }
        }
    } else {
        const bnameArray = bname.split('_');
        if (bnameArray.length > 2) {
            const checkIndex = bnameArray[bnameArray.length - 1] === 'PROLONG' ? [bnameArray.length - 2] : [bnameArray.length - 1]
            days = isNaN(bnameArray[checkIndex]) ? 7 : parseInt(bnameArray[checkIndex])
        }    
    }
    return { days, appendTitle: ' na ' + days + ' dní' };
}

export function computeMixiProlong(productDetail) {
    let list = [];
    try {   
        let res = _.filter(productDetail.product.subscriberWallets, function(fp) { return  fp.type && _.startsWith((fp.type || '').toUpperCase(), 'MENUPACKAGE')});
        const prolBucketsDef = _.filter(productDetail.mixMenu, function(pb) { return !_.isEmpty(pb.deactCommand) });
        const evidenceFilter = _.uniq(_.map(prolBucketsDef, function(mp) { return mp.deactCommand.type }));
        const bqNames = _.filter(res, function(fb) { return _.indexOf(evidenceFilter, fb.type) === -1 });
        let prolongList = [];
        _.forEach(bqNames, function(bActive) {
            if (bActive.buckets.nextChargeDate !== undefined) {
                if (moment(productDetail.timeStamp) < moment(bActive.buckets.nextChargeDate)) {
                    const days = bActive.buckets.name.match(/\d+/g)
                    bActive.days = days === null ? '7' : days[0];
                    bActive.dateReadable = moment(bActive.buckets.nextChargeDate).format('D.M.YYYY')
                    prolongList.push(bActive)
                }
            }
        })
        _.forEach(_.uniqBy(prolongList, function(pl) { return pl.days}), function(bActiveDate) {
            const matchDays = _.filter(res, function(fb) { 
                let days = fb.type.match(/\d+/g);
                days = days === null ? '7' : days[0];
                return _.indexOf(evidenceFilter, fb.type) !== -1 && days === bActiveDate.days });
                if (matchDays.length > 0) {
                    const confBq = _.filter(prolBucketsDef, function(cb) { return cb.bucketName === matchDays[0].buckets.name})[0] || {};
                    list.push({ commgroup: confBq.commgroup, deactCommand: confBq.deactCommand.value, readable: confBq.readable, dateReadable: bActiveDate.dateReadable, days: bActiveDate.days })
                }
        });
    } catch(e) { console.error(e.message) }
    return list
}